import { makeStyles } from '@material-ui/core'

import styles from '../ProgramList.style'

const useStyles = makeStyles(styles)

export { useStyles }
